export default {
  text: {
    en: `
      You may have noticed that your order didn't arrive on your doorstep this month.
      It looks like we had some trouble delivering it because of the wrong shipping address.
    `,
  },
}
